import React, { useEffect, useState } from "react";
import { Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import lazy from "utils/lazy";
import AuthGuard from "auth-guard/index";
import Login from "components/login/Login";
import Register from "components/login/Register";
import TrainerRegister from "components/login/TrainerRegister";
import ForgetPassword from "components/login/ForgetPassword";
import ResetPassword from "components/login/ResetPassword";
import AuthLayout from "components/hfnauth/authLayout";
import HFNauth from "components/hfnauth";

import HFNErrorBoundary from "shared-components/errorBoundary";
import HFNLoader from "shared-components/lazyLoading";
import HFNToaster from "shared-components/toasters";
import HFNConfirmDialog from "shared-components/confirmDialog";
import HFNGallery from "shared-components/gallery";
import TokenExpire from "shared-components/logout/tokenExpire";

import { getAppMode, isWebsiteUnderMaintenance } from "utils/common";
import config from "assets/config";

const LayoutContainer = lazy("layouts/Template");

const App = () => {
  const [underMaintenance, setUnderMaintenance] = useState(false);

  useEffect(() => {
    isWebsiteUnderMaintenance().then((res) => setUnderMaintenance(res));
  }, []);

  useEffect(() => {
    if (underMaintenance) {
      import("hfn-maintenance-web/main");
    }
  }, [underMaintenance]);

  useEffect(() => {
    import("hfn-appmode/main");
  }, []);

  return (
    <>
      <hfn-app-mode appMode={getAppMode(config.appMode)} displayOn="topMiddle" />

      {underMaintenance ? (
        <hfn-Maintenance-web />
      ) : (
        <HFNErrorBoundary>
          <HFNLoader>
            <AuthLayout />
            <div className="hfn">
              <Switch>
                <Login path="/login" />
                <Register path="/register" />
                <TrainerRegister path="/trainer-register" />
                <HFNauth path="/hfnauth/authorization" />
                <ForgetPassword path="/forgot-password" />
                <ResetPassword path="/reset-password/:id" />
                <AuthGuard path="/" component={LayoutContainer} />
                <Redirect to="login" />
              </Switch>
            </div>
            <div>
              <HFNToaster />
              <HFNConfirmDialog />
              <HFNGallery />
              <TokenExpire />
              {/* <HFNReactJoyride /> */}
            </div>
          </HFNLoader>
        </HFNErrorBoundary>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  ld: state.loginDetails,
});

export default withRouter(connect(mapStateToProps)(App));
